/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { defineMessages } from 'react-intl';

export const reviewEndpointMessages = defineMessages({
    pageTitle: {
        id: 'portal.reviewEndpointUtterances.pageTitle',
        defaultMessage: 'Review Endpoint Utterances'
    },
    description: {
        id: 'portal.reviewEndpointUtterances.description',
        defaultMessage: 'LUIS is uncertain of these utterances. Review for correct intent and entities.'
    },
    deleteUtteranceTitle: {
        id: 'portal.reviewEndpointUtterances.deleteUtteranceTitle',
        defaultMessage: 'Delete utterance'
    },
    deleteUtteranceBody: {
        id: 'portal.reviewEndpointUtterances.deleteUtteranceBody',
        defaultMessage: "Are you sure you want to delete this utterance from the app's unlabeled data?"
    },
    addToastStart: {
        id: 'portal.reviewEndpointUtterances.addToastStart',
        defaultMessage: 'Adding suggestion(s) ...'
    },
    addToastSuccess: {
        id: 'portal.reviewEndpointUtterances.addToastSuccess',
        defaultMessage: 'Add suggestion(s) completed'
    },
    addToastFailed: {
        id: 'portal.reviewEndpointUtterances.addToastFailed',
        defaultMessage: 'Add suggestion(s) failed'
    },
    deleteToastStart: {
        id: 'portal.reviewEndpointUtterances.deleteToastStart',
        defaultMessage: 'Deleting suggestion(s) ...'
    },
    deleteToastSuccess: {
        id: 'portal.reviewEndpointUtterances.deleteToastSuccess',
        defaultMessage: 'Delete suggestion(s) completed'
    },
    deleteToastFailed: {
        id: 'portal.reviewEndpointUtterances.deleteToastFailed',
        defaultMessage: 'Delete suggestion(s) failed'
    },
    multiFailureMessage: {
        id: 'portal.reviewEndpointUtterances.multiFailureMessage',
        defaultMessage: '{count} utterances failed'
    },
    unsavedLabelsModalTitle: {
        id: 'portal.reviewEndpointUtterances.unsavedLabelsModalTitle',
        defaultMessage: 'Discard unsaved labels?'
    },
    unsavedLabelsModalDesc: {
        id: 'portal.reviewEndpointUtterances.unsavedLabelsModalDesc',
        defaultMessage: 'Some labels have not been submitted. If you continue, your labels will not be saved.'
    },
    unsavedLabelsModalContinueBtn: {
        id: 'portal.reviewEndpointUtterances.unsavedLabelsModalContinueBtn',
        defaultMessage: 'Continue'
    }
});
